import React from "react";
import classes from "./NavBar.module.css";
import { Link } from "react-router-dom";
import Container from "../utils/Container";
import useUserStore from "../store/useUserStore";
import CartBox from "./CartBox";
import ButtonLink from "../utils/ButtonLink";
import logo from "../assests/images/Logo.png";
import { useNavigate } from "react-router-dom";
import NavHumburger from "./NavHumburger";
export default function NavBar() {
  const { user, userLogout } = useUserStore((state) => state);

  const navigate = useNavigate();
  const logoutHandler = (state) => {
    userLogout(state);
    navigate("/");
  };
  return (
    <Container>
      <nav className={classes.navbar}>
        <NavHumburger />
        <div className={classes.navBarLinks}>
          <div onClick={() => navigate("/")} className={classes.navbarLogoBox}>
            <img src={logo} alt="logo" />
          </div>
          <ul className={classes.navbarList}>
            <li>
              <Link className={classes.navLink} to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className={classes.navLink} to="/all-products">
                All Products
              </Link>
            </li>
            <li>
              <Link className={classes.navLink} to="/wine">
                Wine
              </Link>
            </li>
            <li>
              <Link className={classes.navLink} to="/beer">
                Beer
              </Link>
            </li>
            <li>
              <Link className={classes.navLink} to="/spirits">
                Spirits
              </Link>
            </li>
          </ul>
          <div>
            {user?.isAdmin && (
              <ButtonLink class={classes.media} to="/add-product">
                Add Product
              </ButtonLink>
            )}
          </div>
        </div>
        <div className={classes.navbarActions}>
          <ul className={classes.navbarActoinsList}>
            <li>
              {user ? (
                <div className={classes.navbarUser}>{user.name}</div>
              ) : (
                <Link className={classes.navbarUserAction} to="/login">
                  Login
                </Link>
              )}
            </li>
            <li>
              {user ? (
                <div onClick={logoutHandler} className={classes.navbarUser}>
                  Logout
                </div>
              ) : (
                <Link className={classes.navbarUserAction} to="/signup">
                  Signup
                </Link>
              )}
            </li>
          </ul>

          {user && <CartBox onClick={() => navigate("/cart")} />}
        </div>
      </nav>
    </Container>
  );
}
